import { Timestamp } from '@farmfree/common/firebase/firebaseTypes'

// 서버에서 받은 Timestamp 형태
interface ServerTimestamp {
  seconds: number
  nanoseconds: number
}

// 서버에서 클라이언트로 변환 가능한 타입들
type ServerValue = unknown

// 클라이언트에서 사용할 타입들 (Firebase 네이티브 타입 포함)
type ClientValue = unknown

/**
 * 서버 JSON → 클라이언트 Timestamp 변환 (완전 재귀)
 *
 * HTTP API 응답을 받았을 때 사용
 * {seconds, nanoseconds} 형태를 Timestamp 객체로 변환
 *
 * @example
 * const response = await fetch('/api/orders')
 * const data = await response.json()
 * const orders = fromServerData(data) // Timestamp 객체로 복원
 */
export function fromServerData(obj: ServerValue): ClientValue {
  if (obj === null || typeof obj !== 'object') return obj
  if (Array.isArray(obj)) return obj.map(fromServerData)

  // Timestamp인지 체크
  if (
    obj &&
    typeof obj === 'object' &&
    !Array.isArray(obj) &&
    'seconds' in obj &&
    'nanoseconds' in obj &&
    typeof (obj as ServerTimestamp).seconds === 'number' &&
    typeof (obj as ServerTimestamp).nanoseconds === 'number'
  ) {
    const timestamp = obj as ServerTimestamp
    return new Timestamp(timestamp.seconds, timestamp.nanoseconds)
  }

  // 나머지는 재귀
  const result: Record<string, ClientValue> = {}
  for (const key in obj as Record<string, unknown>) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      result[key] = fromServerData((obj as Record<string, unknown>)[key])
    }
  }
  return result
}
